// Pixley Originals shows whose episodes end with a fixed, branded outro baked into the video file.
// `seconds`   = length of that outro at the very end of every episode file of the show.
// `buttonsAt` = how many seconds into the outro the player's end-card buttons pop in
//               (after the iris-out and the logo have landed).
// The outro video leaves the right ~40% of the frame empty for these buttons, so nothing
// call-to-action is ever burned into the video itself.
//
// Keyed by show name because a new season's storyverse_shows row is only created when its
// first episode is published; add the id to `byId` once it exists.
export const ORIGINALS_OUTROS = {
  byId: {
    '9999f7ba-c613-44b5-8be6-90ff427cc4e4': { seconds: 14.9, buttonsAt: 1.8 }, // The Case Crew
  },
  byName: {
    'The Case Crew': { seconds: 14.9, buttonsAt: 1.8 },
  },
};

export function getOriginalsOutro(show) {
  if (!show) return null;
  return ORIGINALS_OUTROS.byId[show.id] || ORIGINALS_OUTROS.byName[show.name] || null;
}
